// extracted by mini-css-extract-plugin
export var actions = "_43-0";
export var actionsContainer = "_43-6";
export var border = "_43-1";
export var childFullHeight = "_43-d";
export var collapse = "_43-2";
export var content = "_43-8";
export var contentChild = "_43-c";
export var fullscreen = "_43-a";
export var headerContainer = "_43-3";
export var headerRow = "_43-5";
export var hidePadding = "_43-9";
export var noScrollX = "_43-e";
export var noScrollY = "_43-f";
export var optOutTopPadding = "_43-b";
export var pagePadding = "_43-7";
export var profile = "_43-g";
export var profileContainer = "_43-h";
export var profileImage = "_43-i";
export var profileMain = "_43-j";
export var profileSubtitle = "_43-l";
export var profileTitle = "_43-k";
export var tabsWrapper = "_43-4";
export var title = "_43-m";